// TheMenu
import {
  Select,
  SelectItem,
  Pagination as TheMenuPagination,
  Typography,
  useTheme
} from '@themenu/design-system'

type PaginationProps = {
  currentPage: number
  totalPages: number
  limit?: number
  handleSizeChange: (val: number) => void
  handlePageChange: (val: number) => void
}

export const Pagination = ({
  currentPage,
  totalPages,
  limit,
  handleSizeChange,
  handlePageChange
}: PaginationProps) => {
  const theme = useTheme()

  const totalPagesOptions = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  )

  return (
    <div>
      <div className="grid gap-4 place-items-center h-max p-2 px-6 lg:flex lg:justify-between lg:items-center lg:gap-0 [&>*:not(:last-child)]:lg:mr-4">
        <div className="flex items-center gap-10 text-gray-600 text-xs my-16">
          <div className="flex justify-end items-center text-gray-600 text-xs">
            <Typography
              id="jump-to-page"
              variant="callout"
              color={theme.colors.content.subdued}
            >
              Itens por página:
            </Typography>

            <div className="w-[90px] ml-2">
              <Select
                id="jump-to-page-select"
                aria-label="Itens por página"
                aria-describedby="jump-to-page"
                defaultValue={limit?.toString() ?? '10'}
                size={40}
                disabled={totalPages < 1}
                autocomplete={false}
                onChange={(itemsQuantity) => {
                  handleSizeChange(parseInt(itemsQuantity))
                }}
              >
                <SelectItem key="10" textValue="10">
                  10
                </SelectItem>
                <SelectItem key="20" textValue="20">
                  20
                </SelectItem>
                <SelectItem key="50" textValue="50">
                  50
                </SelectItem>
                <SelectItem key="100" textValue="100">
                  100
                </SelectItem>
              </Select>
            </div>
          </div>
          <div className="flex justify-end items-center text-gray-600 text-xs">
            <Typography
              id="go-to-page"
              variant="callout"
              color={theme.colors.content.subdued}
            >
              Ir para página:
            </Typography>
            <div className="w-[90px] ml-2">
              <Select
                id="goToPage"
                aria-label="Ir para página"
                autocomplete={false}
                aria-describedby="go-to-page"
                defaultValue={currentPage.toString()}
                size={40}
                disabled={totalPages < 2}
                onChange={(page) => {
                  const newPage = parseInt(page)
                  handlePageChange(newPage >= 0 ? newPage : 0)
                }}
              >
                {totalPagesOptions.map((page) => {
                  return (
                    <SelectItem key={page} textValue={String(page)}>
                      {page}
                    </SelectItem>
                  )
                })}
              </Select>
            </div>
          </div>
        </div>
        <TheMenuPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChange={handlePageChange}
        />
      </div>
    </div>
  )
}
